"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BerniePluginQualtrics;
var react_1 = __importDefault(require("react"));
var qualtricsInjector_1 = require("./qualtricsInjector");
function BerniePluginQualtrics(options) {
    return {
        name: 'qualtrics-plugin',
        onBrowserHydrateRenderContext: function (context, next) {
            var _a, _b;
            var setAppData = context.setAppData, getAppData = context.getAppData;
            var dyffContext = getAppData().dyffContext;
            var showSurvey = (_b = ((_a = dyffContext === null || dyffContext === void 0 ? void 0 : dyffContext.find(function (feature) { var _a; return feature.featureId === ((_a = options.routes['/partner/campaigns']) === null || _a === void 0 ? void 0 : _a.dyffFeatureId); })) === null || _a === void 0 ? void 0 : _a.result) === true) !== null && _b !== void 0 ? _b : false;
            setAppData({
                showSurvey: showSurvey,
            });
            return next(context);
        },
        onBrowserWrapRootElement: function (context, next) {
            var setRootElement = context.setRootElement, getAppData = context.getAppData;
            var showSurvey = getAppData().showSurvey;
            setRootElement(function (RootElement) {
                var WrappedRootElement = function (props) { return (react_1.default.createElement(qualtricsInjector_1.QualtricsInjector, { routePath: Object.keys(options.routes).find(function (key) { return key === '/partner/campaigns'; }), qualtricsZoneId: options.qualtricsZoneId, qualtricsLink: options.qualtricsLink, showSurvey: showSurvey },
                    react_1.default.createElement(RootElement, __assign({}, props)))); };
                WrappedRootElement.displayName = 'WrappedRootElement';
                return WrappedRootElement;
            });
            return next(context);
        },
    };
}
//# sourceMappingURL=browser.js.map